<template>
    <div class="admin-body">
        <el-row>
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
            </el-breadcrumb>
        </el-row>
        <el-row style="padding: 15px">
            <el-row class="main">
                <el-row style="border-bottom: 1px solid #EEEEEE;">
                    <el-col :xs="24" :sm="12" :md="8" :lg="8">
                        <el-input placeholder="请输入内容" v-model="adminkey" class="input-with-select" @clear="getstart()" clearable>
                            <el-button slot="append" icon="el-icon-search" @click="getstart()"></el-button>
                        </el-input>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="16" :lg="16" style="text-align: right">
                        <el-button type="primary" @click="addd()">新增</el-button>
                        <el-button type="danger" @click="changesel">禁用</el-button>
                        <el-button type="danger" @click="deletesel">删除</el-button>
                    </el-col>
                </el-row>
                <el-table
                        stripe
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        align="left"
                        :data="tableData"
                        style="width: 100%">
                    <el-table-column
                            type="selection"
                            fixed="left"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="user_id"
                            fixed="left"
                            label="用户ID"
                         >
                    </el-table-column>
                    <el-table-column
                            prop="user_name"
                            label="名称">
                    </el-table-column>
                    <el-table-column
                            prop="user_account"
                            label="登录账号">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            width="140">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.user_regtime) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="启用"
                            width="80">
                        <template slot-scope="scope">
                            <el-switch
                                    v-model="scope.row.user_state"
                                    @change="changeAdminState(scope.row.user_id,scope.row.user_state)"
                                    :active-value="1"
                                    :inactive-value="2"
                                    :disabled="scope.row.user_id==1"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">

                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="220">
                        <template slot-scope="scope">
                            <el-button
                                    @click="rpopen(scope.row.user_id)" type="text" size="small">重置密码</el-button>
                            <el-button @click="editAdmin(scope.row)" type="text" size="small">查看/编辑</el-button>
                            <el-button
                                    @click="deleteAdmin(scope.row.user_id,0)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-row>


        <el-dialog title="新增管理员" :visible.sync="addadminVisible" width="400px" :modal-append-to-body="false" top="5vh">
            <el-form :model="addform"  :rules="addrules" ref="addform">
                <el-form-item label="登录账号" :label-width="formLabelWidth" prop="user_account">
                    <el-input clearable v-model="addform.user_account" auto-complete="off" placeholder="请输入登录账号" required></el-input>
                </el-form-item>
                <el-form-item label="账号名称" :label-width="formLabelWidth" prop="user_name">
                    <el-input clearable v-model="addform.user_name" auto-complete="off" placeholder="请输入名称" required></el-input>
                </el-form-item>
                <el-form-item label="登录密码" :label-width="formLabelWidth" prop="user_password">
                    <el-input clearable v-model="addform.user_password" auto-complete="off" type="password" placeholder="密码可以由字母、数字、下划线组成" required></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="againuser_password">
                    <el-input clearable v-model="addform.againuser_password" auto-complete="off" type="password" placeholder="请再一次输入密码" required></el-input>
                </el-form-item>
                <el-form-item label="权限设置" :label-width="formLabelWidth"  prop="permission">
                    <el-checkbox-group v-model="addform.permission" style="text-align: left">
                        <el-checkbox label="1" style="margin-left: 2px">用户管理</el-checkbox>
                        <el-checkbox label="2" style="margin-right: 11px">头像匹配</el-checkbox>
                        <el-checkbox label="3" style="margin-left: 2px">视频管理</el-checkbox>
                        <el-checkbox label="4" style="margin-right: 11px">订单管理</el-checkbox>
                        <el-checkbox label="5" style="margin-left: 2px">财务数据</el-checkbox>
                        <el-checkbox label="6" style="margin-left: 2px">股东与分红</el-checkbox>

                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addadminVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('addform')">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="编辑管理员" :visible.sync="editVisible" width="400px" :modal-append-to-body="false" top="5vh">
            <el-form :model="editform"  :rules="editrules" ref="editform">
                <el-form-item label="登录账号" :label-width="formLabelWidth" prop="user_account">
                    <el-input clearable v-model="editform.user_account" auto-complete="off" placeholder="请输入登录账号" required></el-input>
                </el-form-item>
                <el-form-item label="用户姓名" :label-width="formLabelWidth" prop="user_name">
                    <el-input clearable v-model="editform.user_name" auto-complete="off" placeholder="请输入名字" required></el-input>
                </el-form-item>
                <el-form-item label="权限设置" :label-width="formLabelWidth"  prop="permission">
                    <el-checkbox-group v-model="editform.permission" style="text-align: left">
                      <el-checkbox label="1" style="margin-left: 2px">用户管理</el-checkbox>
                      <el-checkbox label="2" style="margin-right: 11px">头像匹配</el-checkbox>
                      <el-checkbox label="3" style="margin-left: 2px">视频管理</el-checkbox>
                      <el-checkbox label="4" style="margin-right: 11px">订单管理</el-checkbox>
                      <el-checkbox label="5" style="margin-left: 2px">财务数据</el-checkbox>
                      <el-checkbox label="6" style="margin-left: 2px">股东与分红</el-checkbox>

                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="submiteditForm('editform')">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="重置密码" :visible.sync="lookpermissionVisible" width="400px" :modal-append-to-body="false">
            <el-form>
                <el-form-item label="登录密码" :label-width="formLabelWidth" prop="user_password">
                    <el-input clearable v-model="rpp" auto-complete="off" type="password" placeholder="密码可以由字母、数字、下划线组成" required></el-input>
                </el-form-item>
           <el-form-item label="再次输入登录密码" :label-width="formLabelWidth" prop="user_password">
                    <el-input clearable v-model="rpp1" auto-complete="off" type="password" placeholder="密码可以由字母、数字、下划线组成" required></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="lookpermissionVisible = false">取 消</el-button>
                <el-button type="primary" @click="rppppp()">确 定</el-button>
            </div>
        </el-dialog>
        <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
    </div>
</template>

<script>
    export default {
        name: "Admin",
        mounted() {
            if(!this.$store.state.login.in){
                this.$router.push({ name: "login", params: { userId: 123 }})
            }
            this.getstart()
        },
        data() {
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.addform.user_password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                region: 'oss-cn-beijing',
                bucket: 'ycw-img',
                addid: 'addupload',
                editid: 'editupload',
                dataa: [],
                fullscreenLoading: false,
                tableData: [],
                multipleSelection: [],
                rpp:'',
                rpp1:'',
                rppid:'',
                //编辑
                editVisible:false,
                editform: {
                },
                editrules: {
                    user_password:[
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                    ],
                    againuser_password: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    user_account: [
                        { required: true, message: '请输入账号', trigger: 'blur' },
                        { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur' }
                    ],
                    user_name: [
                        { required: true, message: '请输入用户姓名', trigger: 'blur' },
                    ],
                    user_gender :  '',
                    user_cellphone: '',
                    user_weixin :'',
                    user_address :'',
                    user_reasonforopening :'',
                    user_qq :'',
                    user_image :'',
                    permission:  '',
                },
                //新增
                addadminVisible:false,
                formLabelWidth: '130px',
                addform: {
                    user_password:'',
                    againuser_password:'',
                    user_account: '',
                    user_name: '',
                    permission: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16'],
                },
                addrules: {
                    user_password:[
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                    ],
                    againuser_password: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    user_account: [
                        { required: true, message: '请输入账号', trigger: 'blur' },
                        { min: 5, max: 30, message: '长度在 5 到 30 个字符', trigger: 'blur' }
                    ],
                    user_name: [
                        { required: true, message: '请输入用户姓名', trigger: 'blur' },
                    ],
                    permission:  '',
                },
                GenderData:[
                    {
                        Gender_Id : 1,
                        Gender_Name: '男'
                    },
                    {
                        Gender_Id : 2,
                        Gender_Name: '女'
                    },
                ],

                //权限
                lookpermissionVisible:false,
                lookpermissiondata:'',
                //关键字
                adminkey:''
            }
        },
        watch :{
        },
        methods: {
            rppppp(){
                let thi = this
                thi.fullscreenLoading = true
                thi.$http.post(global.posturl.host + global.posturl.changePwd, {
                    user_id: thi.rppid,
                  user_password:thi.rpp,
                  againuser_password:thi.rpp1
                }).then(function (response) {
                    var qcode = response.data.code
                    var qmsg = response.data.msg
                    var qdata = response.data.data
                    console.log(response.data)
                    if(qcode==200){
                        thi.$message({
                            type: 'success',
                            message: '重置成功'
                        });
                        thi.lookpermissionVisible =false
                    }else{
                        thi.$message({
                            type: 'warning',
                            message: qmsg
                        });
                    }

                    thi.fullscreenLoading = false
                }).catch(function (error) {
                    console.log(error)
                });


            },
            rpopen(id){
                this.rppid =id
                this.lookpermissionVisible =true
            },
            getstart() {
                let thi = this
                thi.fullscreenLoading = true
                thi.$http.post(global.posturl.host + global.posturl.listAdminUser, {
                    key: thi.adminkey
                }).then(function (response) {
                    var qcode = response.data.code
                    var qmsg = response.data.msg
                    var qdata = response.data.data
                    console.log(response.data)
                    if(qcode==200){
                        thi.tableData=qdata
                    }if(qcode==886){
                        thi.$message({
                            type: 'warning',
                            message: '请重新登录!'
                        });
                        thi.$router.push({ name: "login", params: { userId: 123 }})
                    }

                    thi.fullscreenLoading = false
                }).catch(function (error) {
                    console.log(error)
                });

            },
            addd(){
                this.addadminVisible=true
                this.addform.permission=['1','2','3','4','5','6']
            },
            //多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            changesel() {
                if(this.multipleSelection.length==0){
                    this.$message({
                        type: 'warning',
                        message: '请选择要禁用的管理员!'
                    });
                    return
                }else{
                    var ids = '';
                    this.multipleSelection.forEach(function(avalue,aindex,aarr){
                        if(aindex==0){
                            ids = avalue.user_id
                        }else {
                            ids = ids+','+avalue.user_id
                        }
                    });
                    this.deleteAdmin(ids,2)
                }

            },
            deletesel() {
                if(this.multipleSelection.length==0){
                    this.$message({
                        type: 'warning',
                        message: '请选择要删除的管理员!'
                    });
                    return
                }else{
                    var ids = '';
                    this.multipleSelection.forEach(function(avalue,aindex,aarr){
                        if(aindex==0){
                            ids = avalue.user_id
                        }else {
                            ids = ids+','+avalue.user_id
                        }
                    });
                    this.deleteAdmin(ids,0)
                }

            },

            deleteAdmin(userid,state) {
                var heeh = '该'
                var caozuo = '禁用'
                if(userid.length>1){
                    heeh='这些'
                }
                if(state==0){
                    caozuo='删除'
                }
                let thi = this
                thi.$confirm('此操作将'+caozuo+heeh+'管理员, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    thi.changeAdminState(userid,state)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'+caozuo
                    });
                });
            },
            //状态改变
            changeAdminState(userid,state) {
                let thi = this
                thi.fullscreenLoading = true
              this.$http.post(global.posturl.host + global.posturl.removeAdminUser, {
                    user_id: userid,
                user_state : state
                }).then(function (response) {
                    var qcode = response.data.code
                    if(qcode==200){
                        thi.getstart()
                    }
                }).catch(function (error) {
                    console.log(error)
                });
            },
            //
            printpermission(index){
                switch (index) {
                    case "1":
                        return "订单信息";
                        break;
                    case "2":
                        return "会员信息";
                        break;
                    case "3":
                        return "财务管理";
                        break;
                    case "4":
                        return "系统设置";
                        break;
                    case 5:
                        return "公众号设置";
                        break;
                    case 6:
                        return "功能设置";
                        break;
                    case 7:
                        return "红包及促销";
                        break;
                    case 8:
                        return "旺客商品";
                        break;
                    default:
                        return null;
                }
            },
            //查看详情
            lookpermission(data){
                this.lookpermissiondata = data;

            },
            //格式化日期
            formatDate (date) {
                if(!date){
                    return "无"
                }
                Date.prototype.toLocaleString = function() {
                    return this.getFullYear() + "-" + (this.getMonth() + 1) + "-" + this.getDate() + " " + this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds();
                };
                var unixTimestamp = new Date(date * 1000)
                return unixTimestamp.toLocaleString();
            },
            //编辑管理员
            editAdmin(row) {
                this.editform= row
                if((this.editform.permission instanceof Array)==false){
                    this.editform.permission = this.editform.permission.split(',');
                }
                this.editVisible = true
                // console.log(this.editform)
            },
            //新增管理员
            submitForm(formName) {
                let thi = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        thi.addform.permission = thi.addform.permission.join(',');
                        thi.fullscreenLoading = true
                        // const dattta = JSON.stringify(thi.addform)
                        // console.log(dattta)
                        this.$http.post(global.posturl.host+global.posturl.addAdminUser,thi.addform
                        ).then(function (response) {
                            var qcode = response.data.code
                            var msg = response.data.msg
                            if(qcode==200){
                                thi.addadminVisible = false
                                thi.getstart()
                            }else{
                                thi.$message({
                                    type: 'info',
                                    message: msg
                                });
                                thi.addform.permission=['1','2','3','4','5','6']
                                thi.fullscreenLoading = false
                            }

                        }).catch(function (error) {
                            console.log(error)
                        });
                    } else {
                        return false;
                    }
                });
            },
            submiteditForm(formName){
                let thi = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        thi.editform.permission = thi.editform.permission.join(',');
                        thi.fullscreenLoading = true
                        // const dattta = JSON.stringify(thi.editform)
                        // console.log(dattta)
                        this.$http.post(global.posturl.host+global.posturl.editAdminUser,thi.editform
                        ).then(function (response) {
                            var qcode = response.data.code
                            console.log(response.data)
                            thi.editVisible = false
                            thi.getstart()
                        }).catch(function (error) {
                            console.log(error)
                        });
                    } else {
                        return false;
                    }
                });
            },

            adddoUpload () {
                const _this = this
                const urls = [];
                _this.$http.post('http://ststest.yuanciwei.com/sts.php').then((result) => {
                    const client = new OSS.Wrapper({
                        region: _this.region,
                        accessKeyId: result.data.AccessKeyId,
                        accessKeySecret: result.data.AccessKeySecret,
                        stsToken: result.data.SecurityToken,
                        bucket: _this.bucket
                    })
                    _this.percentage = 0;
                    const files = document.getElementById(_this.addid)
                    if (files.files) {
                        const fileLen = document.getElementById(_this.addid).files
                        let resultUpload = ''
                        for (let i = 0; i < fileLen.length; i++) {
                            const file = fileLen[i]
                            console.log(file);
                            // 随机命名
                            let random_name = 'wangke/adminimg/'+ new Date().getTime()+this.random_string(6) + '_'  + '.' + file.name.split('.').pop()
                            console.log(random_name);
                            // 上传
                            client.multipartUpload(random_name, file, {
                                progress: function* (percentage, cpt) {
                                    // 上传进度
                                    _this.percentage = parseInt(percentage*100)
                                }
                            }).then((results) => {
                                // 上传完成
                                const url = 'http://img.yuanciwei.com/'+ results.name;
                                _this.addform.user_image = url;
                                console.log(url);
                            }).catch((err) => {
                                console.log(err)
                            })
                        }
                    }
                })
            },
            editdoUpload () {
                const _this = this
                const urls = [];
                _this.$http.post('http://ststest.yuanciwei.com/sts.php').then((result) => {
                    const client = new OSS.Wrapper({
                        region: _this.region,
                        accessKeyId: result.data.AccessKeyId,
                        accessKeySecret: result.data.AccessKeySecret,
                        stsToken: result.data.SecurityToken,
                        bucket: _this.bucket
                    })
                    _this.percentage = 0;
                    const files = document.getElementById(_this.editid)
                    if (files.files) {
                        const fileLen = document.getElementById(_this.editid).files
                        let resultUpload = ''
                        for (let i = 0; i < fileLen.length; i++) {
                            const file = fileLen[i]
                            console.log(file);
                            // 随机命名
                            let random_name = 'wangke/adminimg/'+ new Date().getTime()+this.random_string(6) + '_'  + '.' + file.name.split('.').pop()
                            console.log(random_name);
                            // 上传
                            client.multipartUpload(random_name, file, {
                                progress: function* (percentage, cpt) {
                                    // 上传进度
                                    _this.percentage = parseInt(percentage*100)
                                }
                            }).then((results) => {
                                // 上传完成
                                const url = 'http://img.yuanciwei.com/'+ results.name;
                                _this.editform.user_image = url;
                                console.log(url);
                            }).catch((err) => {
                                console.log(err)
                            })
                        }
                    }
                })
            },

            // 随机生成文件名
            random_string(len) {
                len = len || 32;
                var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz';
                var maxPos = chars.length;
                var pwd = '';
                for (let i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },

        }
    }
</script>

<style scoped>
.admin-body{
    /*background-color: white;*/
    width: 100%;
}
    .main{
        background-color: white;
        min-height: 500px;
        padding: 10px;
        border: #EDEDED 1px solid;
        border-radius: 5px;
    }
    .lookp{
        margin-right: 20px;
    }
.el-col {
    margin-bottom: 10px;
}
.el-select{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/admin/Admin.vue